import React from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import NotFoundPage from '../../containers/NotFoundPage/NotFoundPage';
import { getListingsById } from '../../ducks/marketplaceData.duck';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';
import { DISCOVERY_HOMEPAGE_ASSET_NAME } from '../LandingPage/LandingPage.duck';
const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

export const CMSPageComponent = props => {
  const {
    params,
    pageAssetsData,
    inProgress,
    error,
    projects,
    isFeaturedListing,
    queryProjectsInProgress,
    queryProjectsError,
    isAuthenticated,
    onToggleFavorite,
  } = props;
  const pageId = params.pageId || props.pageId;

  if (!inProgress && error?.status === 404) {
    return <NotFoundPage staticContext={props.staticContext} />;
  }

  // Only the discovery-homepage asset reuses landing-page sections that need
  // project/featured-listing data (see CMSPage.duck.js loadData).
  const isDiscoveryHomepage = pageId === DISCOVERY_HOMEPAGE_ASSET_NAME;

  return (
    <PageBuilder
      pageAssetsData={pageAssetsData?.[pageId]?.data}
      inProgress={inProgress}
      schemaType="Article"
      projects={isDiscoveryHomepage ? projects : undefined}
      onToggleFavorite={onToggleFavorite}
      queryProjectsInProgress={queryProjectsInProgress}
      queryProjectsError={queryProjectsError}
      options={
        isDiscoveryHomepage
          ? {
            projects,
            isFeaturedListing,
            isAuthenticated,
            onToggleFavorite,
            queryProjectsInProgress,
            queryProjectsError,
          }
          : undefined
      }
    />
  );
};

CMSPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  const { projectRefs, isFeatured, queryProjectsInProgress, queryProjectsError } =
    state.LandingPage || {};
  const { isAuthenticated } = state.auth;
  const projects = getListingsById(state, projectRefs);
  const isFeaturedListing = getListingsById(state, isFeatured);
  return {
    pageAssetsData,
    inProgress,
    error,
    projects,
    isFeaturedListing,
    queryProjectsInProgress,
    queryProjectsError,
    isAuthenticated,
  };
};

const mapDispatchToProps = dispatch => ({
  onToggleFavorite: data => dispatch(updateProfile(data)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const CMSPage = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(CMSPageComponent);

export default CMSPage;
